import React from "react";
import { CameraIcon, ClipboardCheckIcon, FileTextIcon, MapIcon, Table2Icon, PrinterIcon } from "lucide-react";
import { tools } from "../../data/content";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
const iconMap: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  sheet: FileTextIcon,
  checklist: ClipboardCheckIcon,
  map: MapIcon,
  matrix: Table2Icon,
  camera: CameraIcon
};
export function Tools() {
  return <section className="bg-navy px-5 py-16 md:py-24" data-id="element-312" data-mp="23swjkn84h2p8">
      <div className="mx-auto max-w-4xl" data-id="element-313" data-mp="23rbtb9suc5x6">
        <SectionHeading dark eyebrow="Also included" title={<>
              You'll also receive these <em className="italic text-gold" data-id="element-315" data-mp="1tvrvghupux5s">professional case-review tools</em>
            </>} data-id="element-314" data-mp="1yta74g04bqhh" />

        <ul className="mt-10 divide-y divide-white/10 overflow-hidden rounded-3xl bg-navy-light" data-id="element-316" data-mp="1ps2ae2d92xpi">
          {tools.map(t => {
          const Icon = iconMap[t.icon];
          return <li key={t.title} className="flex gap-4 p-5 md:p-6" data-id="element-317" data-mp="15852bn2xzvr2">
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-gold text-navy" data-id="element-318" data-mp="1a17z0430nlbh">
                  <Icon className="h-6 w-6" data-id="element-319" data-mp="w9t6n6n7y7rr" />
                </span>
                <div data-id="element-320" data-mp="10a3hawlyhmcy">
                  <p className="text-[17px] font-bold leading-snug text-white" data-id="element-321" data-mp="10beol6em1c8t">{t.title}</p>
                  <p className="mt-1 text-[15px] leading-relaxed text-white/70" data-id="element-322" data-mp="1nzpjlsxmkhp6">{t.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mt-8 flex items-center justify-center gap-2 text-center text-[17px] font-semibold text-gold" data-id="element-323" data-mp="1ez9g4jgvtakb">
          <PrinterIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-324" data-mp="1jxuhim7ve0ac" />
          Everything is designed to be downloaded, printed and reused.
        </p>

        <SectionCta label="I want access to the complete system" data-id="element-325" data-mp="3m70prqiqr1q" />
      </div>
    </section>;
}